import { TippingCore } from '../../../../core/collections';

export class Tipping extends TippingCore {

}

export default Tipping;